export default {
  title: 'CTA with Hover BG'
}

const Template = args => `
  <cradlepoint-cta-with-hover-bg
    text="${args['text'] ? args['text'] : 'Learn more ways a business can incorporate failover into their operations in our Failover White Paper.'}"
    link="${args['link'] ? args['link'] : '#'}"
    icon="${args['icon'] ? args['icon'] : 'https://img.cradlepoint.com/auto-mapping-folder/2023/08/blog-cta-icon@2x.png'}"
    arrow="${args['arrow'] ? args['arrow'] : 'https://img.cradlepoint.com/auto-mapping-folder/2023/08/blog-cta-arrow@2x.png'}"
    new-tab="${args['new-tab'] ? true : false}"
  ></cradlepoint-cta-with-hover-bg>
`;

export const Default = Template.bind({});

Default.args = {
  'text': 'Learn more ways a business can incorporate failover into their operations in our Failover White Paper.',
  'link': 'https://cradlepoint.com/',
  'icon': 'https://img.cradlepoint.com/auto-mapping-folder/2023/08/blog-cta-icon@2x.png',
  'arrow': 'https://img.cradlepoint.com/auto-mapping-folder/2023/08/blog-cta-arrow@2x.png',
  'new-tab': true
}
